import React from 'react';
import Select from "react-select";
import {Col, Row} from "reactstrap";
import TextLabel from "../../../../../Controls/TextLabel.mjs";
import appLib from "../../../../../libs/appLib.mjs";

const G = window.glob;

const buildOptions = (m = {}) => {
	const player = G.getStatus('Player')||{};
	const players = G.getStatus('Players')||[];
	const roles = player?.roles || [];
	const exclusion = roles.map( r => r.id );
	if ( m.to ) m.to.forEach( v => { exclusion.push(v) });
	const recipients = [];
	players.forEach( p => {
		if ( p.id === player.id) return;
		if ( ! p.roles ) return;
		p.roles.forEach( role => {
			if ( ! role?.id ) return;
			if ( exclusion.includes(role.id) ) return;
			exclusion.push(role.id);
			recipients.push({ value: role.id, label: role.name } );
		})
	});
	return recipients.sort((a, b) => ( a.label > b.label ? 1 : -1 ));
}

const buildValues = (m = {}) => {
	const values= [];
	( m.to || [] ).forEach( to => {
		if ( to.includes('@') ) {
			values.push({value: to, label: to});
		} else {
			const n = appLib.nameByRole( to );
			if ( n ) values.push({ value: to, label: n } );
		}
	});
	return values;
}

const MailEditorTo = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			message: props.message || {},
			value: buildValues( props.message ),
			options: buildOptions( props.message )
		};
		this.onChange = this.onChange.bind(this);
	}
	onChange = (v) => {
		const m = this.props.getter();
		const vals = v ? v.map( r => r.value ) : undefined;
		if ( vals && vals.length ) {
			m.to = vals;
		} else {
			delete m.to;
		}
		this.setState( { value: v, message: m, options: buildOptions(m) });
		this.props.setter( m );
	};
	render() {
		return(
			<Row className={ this.props.error ? 'select error': 'select'}>
				<Col className={"nomobile"}>
					<TextLabel value={"To"} />
				</Col>
				<Col>
					<Select
						menuPortalTarget={document.body}
						styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
						key={ Math.random().toString() }
						placeholder={ G.label('To') + '…' }
						isMulti={true}
						value={ this.state.value }
						options={ this.state.options }
						onChange={ this.onChange }
					/>
				</Col>
			</Row>
		)
	}
};

export default MailEditorTo;
